import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import {creatableSelectStyles} from "./creatableSelectStyles";
import {overviewCardStyles} from "./cardStyles";
import { brandColors } from "../../theme";

export const useOverviewContainerStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {},
        container: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            alignItems: "center",
            gap: theme.spacing(2),
        },
        h2: {
            [theme.breakpoints.down("md")]: {
                fontSize: "32px",
            },
        },
        btn: {
            minWidth: "200px",
            "&:not(:first-child)": {
                marginLeft: "20px",
                [theme.breakpoints.down("md")]: {
                    marginLeft: "10px",
                },
            },
            padding: "10px",
        },
        buttonContainer: {
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            marginTop: theme.spacing(2),
        },
        buttonMargin: {
            marginBottom: theme.spacing(1),
            marginLeft: "10px",
            marginRight: "10px",
            width: "250px",
            fontWeight: "bold",
        },
        toggleButtonMargin: {
            marginBottom: theme.spacing(2),
        },
        toggleCardContainer: {
            marginTop: theme.spacing(3),
        },
        toggleCardContent: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
        toggleCardTitle: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(2),
        },
        ...overviewCardStyles(theme),
        card: {
            margin: "25px 0",
        },
        cardReport: {
            flex: "2",
        },
        tableTitle: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(3),
        },
        outputTableTopLabel: {
            marginBottom: theme.spacing(1),
            marginLeft: theme.spacing(2),
        },
        table: {
            "& .MuiTableBody-root .MuiTableRow-root:nth-child(odd)": {
                backgroundColor: theme.palette.grey[50],
            },
            "& .MuiTableCell-root": {
                border: "none",
                paddingTop: 0,
                paddingBottom: 0,
                height: theme.spacing(4),
            },
            "& .MuiTableCell-head": {
                color: "inherit",
                fontSize: "12px",
                fontWeight: 700,
                backgroundColor: theme.palette.grey[300],
            },
        },
        tableContainer: {
            maxHeight: "450px",
            overflowY: "auto",
            "& .MuiOutlinedInput-input": {
                ...theme.typography.caption,
                fontWeight: 500,
                color: theme.palette.primary.main,
            },
        },
        iconBtn: {
            padding: 0,
            marginLeft: theme.spacing(2),
        },
        companyName: {
            fontWeight: 500,
            color: theme.palette.primary.main,
        },
        paginationContainer: {
            display: "flex",
            justifyContent: "flex-end",
            marginTop: theme.spacing(3),
        },
        addButton: {
            minWidth: "200px",
        },
        noPadding: {
            padding: 0,
        },
        circularProgress: {
            margin: "80px",
            width: "48px",
            height: "48px",
        },
        soldVolumesTotal: {
            "& .MuiTableCell-root": {
                fontWeight: 700,
                paddingTop: theme.spacing(1.5),
                paddingBottom: theme.spacing(1.5),
                paddingRight: theme.spacing(3.8),
            },
        },
        bgGreen: {
            backgroundColor: brandColors.success.bg,
        },
        bgRed: {
            backgroundColor: brandColors.secondary.bg,
        },
        green: {
            backgroundColor: brandColors.success.bg,
        },
        red: {
            backgroundColor: brandColors.secondary.bg,
        },
        yellow: {
            backgroundColor: brandColors.primary.light,
        },
        infoBox: {
            display: "flex",
            alignItems: "flex-start",
            gap: theme.spacing(1.5),
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            padding: theme.spacing(2),
            textAlign: "left",
            backgroundColor: theme.palette.grey[50],
            borderLeft: `4px solid ${brandColors.tertiary.main}`,
            borderRadius: theme.shape.borderRadius,
        },
        infoBoxIcon: {
            color: brandColors.tertiary.main,
            marginRight: 12,
            flexShrink: 0,
        },
        infoBoxText: {
            flex: 1,
        },
        ...creatableSelectStyles(theme),
        creatableSelectPrimaryBorder: {
            "& .react-select__control": {
                borderColor: theme.palette.primary.main,
                "&:hover": {
                    borderColor: theme.palette.primary.main,
                },
            },
        },
    })
);

export const useOverviewTableStyles = makeStyles((theme: Theme) =>
    createStyles({
        tableContainer: {
            padding: theme.spacing(3),
            paddingTop: 0,
        },
        table: {
            border: `1px solid ${theme.palette.grey[300]}`,
            "& .MuiTableCell-root": {
                border: `1px solid ${theme.palette.grey[300]}`,
                padding: theme.spacing(1),
                ...theme.typography.body2,
            },
            "& .MuiTableCell-head": {
                color: "inherit",
                fontWeight: 500,
            },
        },
        green: {
            backgroundColor: brandColors.success.bg,
        },
        red: {
            backgroundColor: brandColors.secondary.bg,
        },
        yellow: {
            backgroundColor: brandColors.primary.light,
        },
    })
);
